import AdultIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/adult';
import AirConditioningIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/aircon';
import AlertActiveIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/alert--active';
import BabyCarriageIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/baby-carriage';
import BarIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/bar';
import BusIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/bus';
import BusinessIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/business';
import CafeIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/cafe';
import CallBackIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/call-back';
import CarsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/cars';
import ChildSeatIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/child-seat';
import CloakroomIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/cloakroom';
import DurationIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/duration';
import ElectricIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/electric';
import EstimatedIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/estimated';
import FastTrackIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/fast-track';
import FlaskIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/flask';
import FoodIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/food';
import GlobeIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/globe';
import FitnessIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/health-fitness';
import HotelsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels';
import DisabledFacilitiesIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels--disabled-facilities';
import JacuzziIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels--jacuzzi';
import PetsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels--pets-allowed';
import SmokingIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/hotels--smoking';
import InformationIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/information';
import LockIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/lock';
import LoungeIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/lounge';
import LuggageallIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/luggageall';
import MealIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/meal';
import MediaIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/media';
import NewsIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/news';
import NotAllowedIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/not-allowed';
import OnsenIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/onsen';
import PaperclipIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/paperclip';
import ParkingIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/parking';
import PhoneCallIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/phone-call';
import ServicesIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/services';
import SwapVerticalIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/swap--vertical';
import TicketIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/ticket';
import TimeIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/time';
import ViewIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/view';
import WeatherIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/weather';
import WifiIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/wifi';
import AdultIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/adult';
import AirConditioningIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/aircon';
import AlertActiveIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/alert--active';
import BabyCarriageIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/baby-carriage';
import BarIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/bar';
import BusIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/bus';
import BusinessIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/business';
import CafeIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/cafe';
import CallBackIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/call-back';
import CarsIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/cars';
import ChildSeatIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/child-seat';
import CloakroomIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/cloakroom';
import DurationIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/duration';
import ElectricIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/electric';
import EstimatedIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/estimated';
import FastTrackIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/fast-track';
import FlaskIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/flask';
import FoodIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/food';
import GlobeIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/globe';
import FitnessIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/health-fitness';
import HotelsIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels';
import DisabledFacilitiesIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels--disabled-facilities';
import JacuzziIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels--jacuzzi';
import PetsIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels--pets-allowed';
import SmokingIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/hotels--smoking';
import InformationIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/information';
import LockIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/lock';
import LoungeIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/lounge';
import LuggageallIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/luggageall';
import MealIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/meal';
import MediaIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/media';
import NewsIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/news';
import NotAllowedIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/not-allowed';
import OnsenIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/onsen';
import PaperclipIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/paperclip';
import ParkingIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/parking';
import PhoneCallIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/phone-call';
import ServicesIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/services';
import SwapVerticalIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/swap--vertical';
import TicketIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/ticket';
import TimeIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/time';
import ViewIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/view';
import WeatherIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/weather';
import WifiIconSm from '@skyscanner/backpack-web/bpk-component-icon/sm/wifi';

import type { ObjectMappingEnhance } from './types';

const AMENITY_TYPE_MAP: ObjectMappingEnhance = {
  HOTEL_AMENITY_WIFI_SERVICE: WifiIcon,
  'HOTEL_AMENITY_WIFI_SERVICE--sm': WifiIconSm,
  HOTEL_AMENITY_BROADBAND_SERVICE: GlobeIcon,
  'HOTEL_AMENITY_BROADBAND_SERVICE--sm': GlobeIconSm,
  HOTEL_AMENITY_INTERNET_ACCESS_SERVICE: GlobeIcon,
  'HOTEL_AMENITY_INTERNET_ACCESS_SERVICE--sm': GlobeIconSm,
  HOTEL_AMENITY_INDOOR_SWIMMING_POOL: JacuzziIcon,
  'HOTEL_AMENITY_INDOOR_SWIMMING_POOL--sm': JacuzziIconSm,
  HOTEL_AMENITY_POOL: JacuzziIcon,
  'HOTEL_AMENITY_POOL--sm': JacuzziIconSm,
  HOTEL_AMENITY_ROOM_POOL: JacuzziIcon,
  'HOTEL_AMENITY_ROOM_POOL--sm': JacuzziIconSm,
  HOTEL_AMENITY_ROOM_JACUZZI: JacuzziIcon,
  'HOTEL_AMENITY_ROOM_JACUZZI--sm': JacuzziIconSm,
  HOTEL_AMENITY_JACUZZI_BATHTUB: JacuzziIcon,
  'HOTEL_AMENITY_JACUZZI_BATHTUB--sm': JacuzziIconSm,
  HOTEL_AMENITY_JACUZZI: JacuzziIcon,
  'HOTEL_AMENITY_JACUZZI--sm': JacuzziIconSm,
  HOTEL_AMENITY_HOT_SPRING: JacuzziIcon,
  'HOTEL_AMENITY_HOT_SPRING--sm': JacuzziIconSm,
  HOTEL_AMENITY_PRIVATE_HOT_SPRING_BATH: JacuzziIcon,
  'HOTEL_AMENITY_PRIVATE_HOT_SPRING_BATH--sm': JacuzziIconSm,
  HOTEL_AMENITY_AIR_CONDITIONING: AirConditioningIcon,
  'HOTEL_AMENITY_AIR_CONDITIONING--sm': AirConditioningIconSm,
  HOTEL_AMENITY_BALCONY: WeatherIcon,
  'HOTEL_AMENITY_BALCONY--sm': WeatherIconSm,
  HOTEL_AMENITY_ROOM_WITH_A_SEA_VIEW: ViewIcon,
  'HOTEL_AMENITY_ROOM_WITH_A_SEA_VIEW--sm': ViewIconSm,
  HOTEL_AMENITY_ROOM_WITH_A_LAKE_VIEW: ViewIcon,
  'HOTEL_AMENITY_ROOM_WITH_A_LAKE_VIEW--sm': ViewIconSm,
  HOTEL_AMENITY_ROOM_WITH_A_MOUNTAIN_VIEW: ViewIcon,
  'HOTEL_AMENITY_ROOM_WITH_A_MOUNTAIN_VIEW--sm': ViewIconSm,
  HOTEL_AMENITY_ROOM_WITH_A_VIEW: ViewIcon,
  'HOTEL_AMENITY_ROOM_WITH_A_VIEW--sm': ViewIconSm,
  HOTEL_AMENITY_DISABLED_FACILITY: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_DISABLED_FACILITY--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_EARLY_CHECKIN_SERVICE: TimeIcon,
  'HOTEL_AMENITY_EARLY_CHECKIN_SERVICE--sm': TimeIconSm,
  HOTEL_AMENITY_LATE_CHECKOUT_SERVICE: TimeIcon,
  'HOTEL_AMENITY_LATE_CHECKOUT_SERVICE--sm': TimeIconSm,
  HOTEL_AMENITY_COT: BabyCarriageIcon,
  'HOTEL_AMENITY_COT--sm': BabyCarriageIconSm,
  HOTEL_AMENITY_EXTRA_BED: HotelsIcon,
  'HOTEL_AMENITY_EXTRA_BED--sm': HotelsIconSm,
  HOTEL_AMENITY_AIRPORT_SHUTTLE_SERVICE: BusIcon,
  'HOTEL_AMENITY_AIRPORT_SHUTTLE_SERVICE--sm': BusIconSm,
  HOTEL_AMENITY_PARKING: ParkingIcon,
  'HOTEL_AMENITY_PARKING--sm': ParkingIconSm,
  HOTEL_AMENITY_SPA: JacuzziIcon,
  'HOTEL_AMENITY_SPA--sm': JacuzziIconSm,
  HOTEL_AMENITY_DESK: PaperclipIcon,
  'HOTEL_AMENITY_DESK--sm': PaperclipIconSm,
  HOTEL_AMENITY_COFFEE_MAKER: CafeIcon,
  'HOTEL_AMENITY_COFFEE_MAKER--sm': CafeIconSm,
  HOTEL_AMENITY_KITCHENETTE: FoodIcon,
  'HOTEL_AMENITY_KITCHENETTE--sm': FoodIconSm,
  HOTEL_AMENITY_MICROWAVE: FoodIcon,
  'HOTEL_AMENITY_MICROWAVE--sm': FoodIconSm,
  HOTEL_AMENITY_SATELLITE_TV: MediaIcon,
  'HOTEL_AMENITY_SATELLITE_TV--sm': MediaIconSm,
  HOTEL_AMENITY_DVD_VIDEO_PLAYER: MediaIcon,
  'HOTEL_AMENITY_DVD_VIDEO_PLAYER--sm': MediaIconSm,
  HOTEL_AMENITY_VIDEOGAME_SERVICE: MediaIcon,
  'HOTEL_AMENITY_VIDEOGAME_SERVICE--sm': MediaIconSm,
  HOTEL_AMENITY_FAX: PhoneCallIcon,
  'HOTEL_AMENITY_FAX--sm': PhoneCallIconSm,
  HOTEL_AMENITY_FITNESS_CENTER: FitnessIcon,
  'HOTEL_AMENITY_FITNESS_CENTER--sm': FitnessIconSm,
  HOTEL_AMENITY_PETS_ALLOWED_SERVICE: PetsIcon,
  'HOTEL_AMENITY_PETS_ALLOWED_SERVICE--sm': PetsIconSm,
  HOTEL_AMENITY_FRONT_DESK_24H_SERVICE: ServicesIcon,
  'HOTEL_AMENITY_FRONT_DESK_24H_SERVICE--sm': ServicesIconSm,
  HOTEL_AMENITY_KITCHEN: FoodIcon,
  'HOTEL_AMENITY_KITCHEN--sm': FoodIconSm,
  HOTEL_AMENITY_BAR: BarIcon,
  'HOTEL_AMENITY_BAR--sm': BarIconSm,
  HOTEL_AMENITY_WHEEL_CHAIR_ACCESS: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_WHEEL_CHAIR_ACCESS--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_SAUNA: OnsenIcon,
  'HOTEL_AMENITY_SAUNA--sm': OnsenIconSm,
  HOTEL_AMENITY_IRONING_SERVICE: CloakroomIcon,
  'HOTEL_AMENITY_IRONING_SERVICE--sm': CloakroomIconSm,
  HOTEL_AMENITY_LUGGAGE_STORAGE: LuggageallIcon,
  'HOTEL_AMENITY_LUGGAGE_STORAGE--sm': LuggageallIconSm,
  HOTEL_AMENITY_STEAM_ROOM: JacuzziIcon,
  'HOTEL_AMENITY_STEAM_ROOM--sm': JacuzziIconSm,
  HOTEL_AMENITY_NON_SMOKING_SERVICE: NotAllowedIcon,
  'HOTEL_AMENITY_NON_SMOKING_SERVICE--sm': NotAllowedIconSm,
  HOTEL_AMENITY_NONSMOKING_FLOOR: NotAllowedIcon,
  'HOTEL_AMENITY_NONSMOKING_FLOOR--sm': NotAllowedIconSm,
  HOTEL_AMENITY_SMOKING_AREA: SmokingIcon,
  'HOTEL_AMENITY_SMOKING_AREA--sm': SmokingIconSm,
  HOTEL_AMENITY_SMOKING_SERVICE: SmokingIcon,
  'HOTEL_AMENITY_SMOKING_SERVICE--sm': SmokingIconSm,
  HOTEL_AMENITY_ROOM_SERVICE: ServicesIcon,
  'HOTEL_AMENITY_ROOM_SERVICE--sm': ServicesIconSm,
  HOTEL_AMENITY_MEETING_ROOM: BusinessIcon,
  'HOTEL_AMENITY_MEETING_ROOM--sm': BusinessIconSm,
  HOTEL_AMENITY_EXPRESS_CHECKIN_SERVICE: FastTrackIcon,
  'HOTEL_AMENITY_EXPRESS_CHECKIN_SERVICE--sm': FastTrackIconSm,
  HOTEL_AMENITY_BATHTUB: OnsenIcon,
  'HOTEL_AMENITY_BATHTUB--sm': OnsenIconSm,
  HOTEL_AMENITY_RESTAURANT: MealIcon,
  'HOTEL_AMENITY_RESTAURANT--sm': MealIconSm,
  HOTEL_AMENITY_WESTERN_RESTAURANT: MealIcon,
  'HOTEL_AMENITY_WESTERN_RESTAURANT--sm': MealIconSm,
  HOTEL_AMENITY_CHINESE_RESTAURANT: MealIcon,
  'HOTEL_AMENITY_CHINESE_RESTAURANT--sm': MealIconSm,
  HOTEL_AMENITY_ALARM_CLOCK: AlertActiveIcon,
  'HOTEL_AMENITY_ALARM_CLOCK--sm': AlertActiveIconSm,
  HOTEL_AMENITY_TELEVISION: MediaIcon,
  'HOTEL_AMENITY_TELEVISION--sm': MediaIconSm,
  HOTEL_AMENITY_TABLE_TENNIS: DurationIcon,
  'HOTEL_AMENITY_TABLE_TENNIS--sm': DurationIconSm,
  HOTEL_AMENITY_LAUNDRY: CloakroomIcon,
  'HOTEL_AMENITY_LAUNDRY--sm': CloakroomIconSm,
  HOTEL_AMENITY_TICKET_OFFICE: TicketIcon,
  'HOTEL_AMENITY_TICKET_OFFICE--sm': TicketIconSm,
  HOTEL_AMENITY_BOTTLED_WATER_SERVICE: FlaskIcon,
  'HOTEL_AMENITY_BOTTLED_WATER_SERVICE--sm': FlaskIconSm,
  HOTEL_AMENITY_LIFT: SwapVerticalIcon,
  'HOTEL_AMENITY_LIFT--sm': SwapVerticalIconSm,
  HOTEL_AMENITY_HEATING: EstimatedIcon,
  'HOTEL_AMENITY_HEATING--sm': EstimatedIconSm,
  HOTEL_AMENITY_SHOWER: OnsenIcon,
  'HOTEL_AMENITY_SHOWER--sm': OnsenIconSm,
  HOTEL_AMENITY_MINI_BAR: BarIcon,
  'HOTEL_AMENITY_MINI_BAR--sm': BarIconSm,
  HOTEL_AMENITY_TOURIST_INFORMATION_OFFICE: InformationIcon,
  'HOTEL_AMENITY_TOURIST_INFORMATION_OFFICE--sm': InformationIconSm,
  HOTEL_AMENITY_CHILDREN_FACILITY: ChildSeatIcon,
  'HOTEL_AMENITY_CHILDREN_FACILITY--sm': ChildSeatIconSm,
  HOTEL_AMENITY_CAR_RENTAL: CarsIcon,
  'HOTEL_AMENITY_CAR_RENTAL--sm': CarsIconSm,
  HOTEL_AMENITY_CONCIERGE_SERVICE: LuggageallIcon,
  'HOTEL_AMENITY_CONCIERGE_SERVICE--sm': LuggageallIconSm,
  HOTEL_AMENITY_TELEPHONE: PhoneCallIcon,
  'HOTEL_AMENITY_TELEPHONE--sm': PhoneCallIconSm,
  HOTEL_AMENITY_SOLARIUM: WeatherIcon,
  'HOTEL_AMENITY_SOLARIUM--sm': WeatherIconSm,
  HOTEL_AMENITY_SAFE_DEPOSIT_BOX: LockIcon,
  'HOTEL_AMENITY_SAFE_DEPOSIT_BOX--sm': LockIconSm,
  HOTEL_AMENITY_WAKE_UP_CALL_SERVICE: CallBackIcon,
  'HOTEL_AMENITY_WAKE_UP_CALL_SERVICE--sm': CallBackIconSm,
  HOTEL_AMENITY_CAFE: CafeIcon,
  'HOTEL_AMENITY_CAFE--sm': CafeIconSm,
  HOTEL_AMENITY_BATHROBE_SERVICE: AdultIcon,
  'HOTEL_AMENITY_BATHROBE_SERVICE--sm': AdultIconSm,
  HOTEL_AMENITY_DAILY_NEWSPAPER_SERVICE: NewsIcon,
  'HOTEL_AMENITY_DAILY_NEWSPAPER_SERVICE--sm': NewsIconSm,
  HOTEL_AMENITY_EXECUTIVE_LOUNGE: LoungeIcon,
  'HOTEL_AMENITY_EXECUTIVE_LOUNGE--sm': LoungeIconSm,
  HOTEL_AMENITY_ELECTRIC_VEHICLE_CHARGING_STATION: ElectricIcon,
  'HOTEL_AMENITY_ELECTRIC_VEHICLE_CHARGING_STATION--sm': ElectricIconSm,
  HOTEL_AMENITY_ACCESSIBLE_PARKING: ParkingIcon,
  'HOTEL_AMENITY_ACCESSIBLE_PARKING--sm': ParkingIconSm,
  HOTEL_AMENITY_ACCESSIBLE_ROOMS_AVAILABLE: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_ACCESSIBLE_ROOMS_AVAILABLE--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_BATHROOM_EMERGENCY_PULL_CORD: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_BATHROOM_EMERGENCY_PULL_CORD--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_BATH_SEAT: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_BATH_SEAT--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_BATH_WITH_GRAB_BAR: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_BATH_WITH_GRAB_BAR--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_HANDRAILS_IN_STAIRWAYS: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_HANDRAILS_IN_STAIRWAYS--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_LOWERED_BATHROOM_SINK: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_LOWERED_BATHROOM_SINK--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_RAISED_TOILET: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_RAISED_TOILET--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_ROLL_IN_SHOWER: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_ROLL_IN_SHOWER--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_SHOWER_WITH_GRAB_BAR: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_SHOWER_WITH_GRAB_BAR--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_TOILET_WITH_GRAB_BAR: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_TOILET_WITH_GRAB_BAR--sm': DisabledFacilitiesIconSm,
  HOTEL_AMENITY_TRANSFER_SHOWER: DisabledFacilitiesIcon,
  'HOTEL_AMENITY_TRANSFER_SHOWER--sm': DisabledFacilitiesIconSm,
};

export default AMENITY_TYPE_MAP;
